module.exports = require("/home/docker/actions-runner/_work/NCWeb/NCWeb/src/store")